import React, { ReactNode, forwardRef } from 'react';

import { IconButtonProps as MuiIconButtonProps } from '@mui/material';

import { IconButtonVariant, StyledIconButton } from './styled';

export interface IconButtonProps extends Omit<MuiIconButtonProps, 'children'> {
	children: ReactNode;
	variant?: IconButtonVariant;
	background?: string;
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
	({ children, variant = 'default', background, ...props }, ref) => (
		<StyledIconButton ref={ref} variant={variant} background={background} {...props}>
			{children}
		</StyledIconButton>
	),
);
